// The SLA hold's reasons and their words, client side (Session AUT). The server's home is
// server/src/modules/sla/slaHold.ts (SLA_HOLD_REASON_LABELS); slaHoldParity.test.ts binds the two.
// Declared here, not imported from ./api, so the server-side parity test can import this file without the browser API.
type SlaHoldReason = "awaiting_payment" | "awaiting_signature" | "awaiting_approval" | "other";

export const SLA_HOLD_REASON_OPTIONS: ReadonlyArray<{ value: SlaHoldReason; label: string }> = [
  { value: "awaiting_payment", label: "awaiting customer payment" },
  { value: "awaiting_signature", label: "awaiting customer signature" },
  { value: "awaiting_approval", label: "awaiting customer approval" },
  { value: "other", label: "other" },
];

// A datetime-local input value ("YYYY-MM-DDTHH:mm") for an instant, in the browser's local time (the office is in
// London), and back to an ISO instant. Empty in, null out.
export function toLocalInputValue(at: Date | string): string {
  const d = at instanceof Date ? at : new Date(at);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInputValue(v: string): string | null {
  if (!v.trim()) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
